import React, { useState } from "react";
import ReactDOM from "react-dom";
import { useSelector } from "react-redux";

import { RootState } from "../../../../globals";
import useEsTelefono from "../../../../utils/esTelefono";
import { getAccessPermissions } from "../../../../common";
import S from "./strings";
import { TabProps } from "./helpers";
import UnaAlumna from "./unaAlumna";
import UnHorario from "./unHorario";
import "./styles.css";
import "./actualizacionesModal.css";

/*
	Un solo camino (Esteban, 2026-10-29): la ficha del alumno (Historial) y la lista de inscritos de Horarios abren el MISMO
	módulo Actualizaciones encima de la pantalla, sin salir de ella. Una Alumna con su matrícula o Un Horario; desde Un Horario,
	«Actualizar» de una persona cambia a Una Alumna aquí mismo. El plantel es el de la barra, como en el módulo.
*/

interface Props {
	studentId?: number | null;
	enrollmentId?: number | null;
	scheduleId?: number | null;
	onClose: () => void;
	/** Algo se pidió o se aplicó: la pantalla de abajo puede recargarse al cerrar. */
	onChanged?: () => void;
}

const ActualizacionesModal: React.FC<Props> = ({ studentId, enrollmentId, scheduleId, onClose, onChanged }) => {
	const movil = useEsTelefono();
	const sessionCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const legacyCampusKey: any = useSelector((state: RootState) => state.currentUserCampus.value);
	const legacyCampusRef: any = useSelector((state: RootState) => state.campusRef.value);
	const legacyCampus: any = legacyCampusKey && legacyCampusRef ? legacyCampusRef[legacyCampusKey] : null;
	const campusId: number | null = legacyCampus?.id ?? sessionCampus?.id ?? null;
	const countryId: number | null = legacyCampus?.company?.country_id ?? (sessionCampus?.id === campusId ? sessionCampus?.countryId : null) ?? null;
	const userProfile: any = useSelector((state: RootState) => state.userProfile.value);
	const canApplyNow: boolean = !!getAccessPermissions(userProfile, "enrollmentUpdates").update;

	const [alumna, setAlumna] = useState<{ studentId?: number; enrollmentId?: number; vez: number } | null>(
		studentId ? { studentId, enrollmentId: enrollmentId || undefined, vez: 0 } : null);
	const [notice, setNotice] = useState<{ text: string; ok: boolean } | null>(null);
	const [cambio, setCambio] = useState<boolean>(false);

	// Sin cerrar con Escape ni con clic afuera: adentro puede haber decisiones a medio llenar (Fusionar, notas).
	const cerrar = () => { if (cambio && onChanged) { onChanged(); } onClose(); };

	if (campusId === null) { return null; }
	const tabProps: TabProps = {
		campusId, countryId, movil, canApplyNow,
		notify: (text, ok = true) => setNotice({ text, ok }),
		changed: () => setCambio(true)
	};
	const enHorario = !alumna && !!scheduleId;

	// Portal al body: la ficha y los prompts de Horarios son react-modal; así no se corta ni hereda sus clics.
	return ReactDOM.createPortal(
		<div className="wau-modal-fondo acm-fondo" role="dialog" aria-modal="true" aria-label={S.title}
			onMouseDown={(e) => e.stopPropagation()} onClick={(e) => e.stopPropagation()}>
			<div className={"acm-hoja" + (movil ? " movil" : "")}>
				<div className="acm-cab">
					<h2>{S.title}</h2>
					{alumna && scheduleId ? <button type="button" className="wau-btn s mini" onClick={() => setAlumna(null)}>{S.unHorario}</button> : null}
					<button type="button" className="acm-cerrar" aria-label={S.close} onClick={cerrar}>×</button>
				</div>
				<div className={"wau" + (movil ? " movil" : "") + " acm-cuerpo"}>
					{notice ? <div className={"wau-aviso " + (notice.ok ? "ok" : "mal")} role="status"><span>{notice.text}</span><button type="button" aria-label={S.close} onClick={() => setNotice(null)}>×</button></div> : null}
					{enHorario
						? <UnHorario key={"h" + campusId} {...tabProps} initialScheduleId={scheduleId || undefined}
							onActualizar={(s, e) => setAlumna((a) => ({ studentId: s, enrollmentId: e, vez: (a?.vez || 0) + 1 }))} />
						: <UnaAlumna key={"a" + campusId + "-" + (alumna?.vez || 0)} {...tabProps} initialStudentId={alumna?.studentId} initialEnrollmentId={alumna?.enrollmentId} />}
				</div>
			</div>
		</div>,
		document.body
	);
};

export default ActualizacionesModal;
